import sliceText from 'components/helpers/sliceText';
import { GlobalContext } from 'Context/GlobalContext/AppContext';
import FileSaver from 'file-saver';
import Tree from 'rc-tree';
import 'rc-tree/assets/index.css';
import { useContext, useRef } from 'react';
import api from 'services/api';
import './styles.scss';

function formatTreeData(links, nts, dps, documents) {
    const treeData = [];

    const ntsNode = {
        key: '1',
        title: 'Normas Técnicas',
        className: 'treeView__parent parent--nts',
        children: nts.map((doc, index) => {
            return {
                key: `1-${index}`,
                title: (
                    <>
                        <a href={`/${doc.UrlDetalhe}`} rel="noreferrer" target="_blank" title={`${doc.UrlDetalhe} - ${doc.Nome}`}>
                            {doc.NDocumento} {sliceText(doc.Nome, 0, 50)}
                        </a>
                    </>
                ),
                className: 'treeView__node treeView__node--nts',
            };
        }),
    };

    const dpsNode = {
        key: '2',
        title: 'Desenho Padrão',
        className: 'treeView__parent parent--dps',
        children: dps.map((doc, index) => {
            return {
                key: `2-${index}`,
                title: (
                    <>
                        <a href={`/${doc.UrlDetalhe}`} rel="noreferrer" target="_blank" title={`${doc.UrlDetalhe} - ${doc.Nome}`}>
                            {sliceText(doc.Nome, 0, 50)}
                        </a>
                    </>
                ),
                className: 'treeView__node treeView__node--dps',
            };
        }),
    };

    const linkNode = {
        key: '3',
        title: 'Outros Documentos',
        className: 'treeView__parent parent--links',
        children: links.map((link, index) => {
            return {
                key: `3-${index}`,
                title: (
                    <>
                        <a
                            title={link.Nome}
                            onClick={() => FileSaver.saveAs(api.getLink(link.ID), link.Nome)}
                            rel="noreferrer"
                            target="_blank"
                        >
                            {sliceText(documents.NRDocumento +' '+ link.Nome, 0, 50)}
                        </a>
                    </>
                ),
                className: 'treeView__node treeView__node--links',
            };
        }),
    };

    if (nts.length > 0) treeData.push(ntsNode);
    if (dps.length > 0) treeData.push(dpsNode);
    if (links.length > 0) treeData.push(linkNode);

    return treeData;
}

const TreeView = () => {
    const {
        treeModal: { documents },
    } = useContext(GlobalContext);
    const { Links, Documentos } = documents;
    const Nts = Documentos.filter((doc) => doc.TipoDoc === 1);
    const Dps = Documentos.filter((doc) => doc.TipoDoc === 2);

    const treeRef = useRef(null);

    return <Tree showIcon={false} selectable={false} ref={treeRef} className="treeView" treeData={formatTreeData(Links, Nts, Dps, documents)} height={350} />;
};

export default TreeView;
